import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { usePageContextQuery } from "@/shared/page-context";
import styles from "./AboutTheseSettingsLink.module.scss";

const SEARCH_TIPS_URL = "/support/s/article/Ancestry-Search-Tips";

export const SEARCH_TIPS_EXACT_ANCHOR = "#tip_exact";
export const SEARCH_TIPS_PLACES_ANCHOR = "#tip_addPlaces";

type SearchTipsAnchor = typeof SEARCH_TIPS_EXACT_ANCHOR | typeof SEARCH_TIPS_PLACES_ANCHOR;

interface AboutTheseSettingsLinkProps {
    anchor: SearchTipsAnchor;
}

export const AboutTheseSettingsLink: FC<AboutTheseSettingsLinkProps> = ({ anchor }) => {
    const { t } = useTranslation();
    const { data: pageContext } = usePageContextQuery();

    const url = `${SEARCH_TIPS_URL}?language=${pageContext.locale}${anchor}`;

    return (
        <div className={styles.about}>
            <a href={url} target="_blank" rel="noopener noreferrer" className="link">
                {t("aboutTheseSettings")}
            </a>
        </div>
    );
};
